import { render, staticRenderFns } from "./ThemePage.vue?vue&type=template&id=080dd2c3&scoped=true&"
import script from "./ThemePage.vue?vue&type=script&lang=js&"
export * from "./ThemePage.vue?vue&type=script&lang=js&"
import style0 from "./ThemePage.vue?vue&type=style&index=0&id=080dd2c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080dd2c3",
  null
  
)

export default component.exports